import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { log } from "console";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { FlashService } from "../../flash/flash.service";
import { ErrorService } from "../../services/error.service";
import { QuestionsService } from "../../services/questions.service";
@Component({
  selector: "app-questionslist",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.css"],
})
export class QuestionslistComponent implements OnInit {
  questions;
  currentPageNo = 1;
  perPage = 25;
  sNo =1;
  totalItems;
  errors;
  delete_id;
  constructor(
    private questionservice: QuestionsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private flashService: FlashService,
    private router: Router,
    private errorService: ErrorService
  ) {}

  ngOnInit() {
    this.getQuestions(this.currentPageNo);
  }

  getQuestions(pgNo: number) {
    if (pgNo != null) {
      this.currentPageNo = pgNo;
    }
    console.log('cp:',this.currentPageNo);
  
    this.questionservice.getQuestions(this.currentPageNo).subscribe((data) => {
      this.questions = data.body.data;
      this.totalItems = data.body.pagination.totalItems;

      if(this.currentPageNo > 1){
        let perPageIndex
        perPageIndex = (this.currentPageNo - 1 )* this.perPage
        this.sNo = perPageIndex + 1
      }else{
        this.sNo = 1
      }
      
    });
  }

  proceed(id:any){
    this.delete_id = id;
   
  }

  deleteQuestion(id) {
    this.spinnerService.show();
    this.questionservice.deleteQuestion(id).subscribe(
      (data: any) => {
        this.spinnerService.hide();
        if (data.body.success) {
          this.flashService.show(data.body["message"], "alert-success");
          this.router.navigateByUrl("questions/list");

          this.getQuestions(1);
        } else {
          this.errors = data.body["message"];
          this.flashService.show(data.body["message"], "alert-danger");
        }
      },
      (error) => {
        this.spinnerService.hide();
        this.errorService.errorHandling(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/questions/list/list.component.ts